/**
 * 格式化时间为指定字符串格式
 * @param {string} [format='YYYY-MM-DD HH:mm:ss'] - 格式模板，默认为 'YYYY-MM-DD HH:mm:ss'
 * @param {Date|number|string} time - 时间值，支持 Date 对象、时间戳（毫秒/秒）或 ISO 字符串，默认得当前时间
 * @returns {string} 格式化后的时间字符串
 */
export default function formatTime(format = 'YYYY-MM-DD HH:mm:ss',time=Date.now()) {

  const date = new Date(time);

  if (isNaN(date.getTime())) {
    return '';
  }

  const padZero = (num) => (num < 10 ? `0${num}` : num);

  const year = date.getFullYear();
  const month = padZero(date.getMonth() + 1); // getMonth 返回 0-11
  const day = padZero(date.getDate());
  const hours = padZero(date.getHours());
  const minutes = padZero(date.getMinutes());
  const seconds = padZero(date.getSeconds());

  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);
}
